<template>
  <div v-if="isShow" :class="{'right-operation' : showRightOperation}" class="right-operation-wrapper">
    <img alt="" class="btn" src="../../assets/images/theme1/excellentCourse/home-btn.png"
         @click="showRightOperation = !showRightOperation">
    <img alt="" src="../../assets/images/theme1/excellentCourse/home-btns.png">
    <div class="operation-wrapper">
      <div class="operation-btn-content">
        <div v-for="item of buttons" :key="item.type" class="operation-btn" @click="go(item)">{{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "../tools/storage";
import httpJourse from "@/components/tools/request/jCourse/https-jCourse.js";
import utils from "@/components/tools/utils.js";
import comHttps from "@/components/tools/request/common.js";

export default {
  name: "entrance",
  data() {
    return {
      isShow: false,
      showRightOperation: true,
      buttons: [],
      pathList: [
        {type: '1', name: '进入高效备授', path: '/homepage'},
        {type: '2', name: '进入在线课程', path: '/excellent/home'},
        {type: '3', name: '进入精准复习', path: '/review/home'}
      ]
    }
  },
  methods: {
    go(item) {
      if (item.type === '0') {
        comHttps.doLogout().then(res => {
          storage.clearUserInfo();
          this.$router.replace("/");
        });
      } else {
        this.$router.push(item.path)
        this.updatePower(item);
      }

    },

    updatePower(item) {
      // console.log(1111)
      let params = {
        type: item.type
      };
      httpJourse.updatePower(params).then(res => {
        if (utils.requestSuccess(res)) {
          const userInfo = storage.getUserInfo();
          if (userInfo) {
            userInfo.mteacherPowerDTOS[0].defaultStatus = res.type
            storage.setUserInfo(userInfo)
          }
        }
      })
    }
  },
  watch: {
    $route: {
      handler(val) {
        if (!storage.getUserInfo() || storage.getUserInfo().userType === 'student') {
          this.isShow = false
          return;
        }
        const types = storage.getUserInfo().mteacherPowerDTOS[0].type.split(',')
        if (types && types.length === 1) return
        this.showRightOperation = true
        this.isShow = this.pathList.map(item => item.path).includes(val.path)
        if (this.isShow) {
          let list = []
          this.pathList.forEach(item => {
            if (types.includes(item.type) && item.path !== val.path) {
              list.push(item)
            }
          })
          this.buttons = list;
          this.buttons.push({type: '0', name: '退出登录', path: ''})
        }
      },
      immediate: true
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

.right-operation {
  transform: translateX(280px);

  .btn {
    animation-name: hd;
  }
}

.right-operation-wrapper {
  position: fixed;
  right: 0;
  top: 450px;
  transition: all .5s;
  height: 180px;
  z-index: 9999;

  .btn {
    position: absolute;
    left: -55px;
    top: 35px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    cursor: pointer;
    z-index: 999;
  }

  .operation-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .operation-btn-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transform: translateX(15px);
      gap: 15px;

      .operation-btn {
        width: 180px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #DEE0FF;
        border-radius: 5px;
        font-size: 16px;
        font-weight: bold;
        transition: all .5s;
        color: #4E54E1;
        cursor: pointer;

        &:hover {
          background: #4E54E1;
          color: #DEE0FF;
        }
      }
    }
  }

  @keyframes hd {
    0% {
    }

    50% {
      left: -55px;
    }

    100% {
      left: -100px;
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/entrance.vue